import {ResourceAllocationState, Role} from '../../../types';
import {removeRoleCascade} from '../cascadeDelete';

export const roleHandlers = {
    RoleAdded: (
        state: ResourceAllocationState,
        data: Role
    ): ResourceAllocationState => {
        return {
            ...state,
            roles: {...state.roles, [data.id]: data}
        };
    },
    RoleUpdated: (
        state: ResourceAllocationState,
        data: {id: string; updates: Partial<Role>}
    ): ResourceAllocationState => {
        return {
            ...state,
            roles: {
                ...state.roles,
                [data.id]: {
                    ...state.roles[data.id],
                    ...data.updates
                }
            }
        };
    },
    RoleDeleted: (
        state: ResourceAllocationState,
        data: {id: string}
    ): ResourceAllocationState => {
        // Mirror the DB cascade: also scrub this role id from every person's roleIds.
        return removeRoleCascade(state, data.id);
    }
};
